import { http } from './config';

const PROPOSAL_PATH = 'proposal';

export default {
  getByCodigo: codigo => http.get(`${PROPOSAL_PATH}/${codigo}`),
  salvar: proposal => http.post(PROPOSAL_PATH, proposal),

  listar: object =>
    http.get(`${PROPOSAL_PATH}?page=${object.page ? object.page : 1}`)
};
